import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'categoryCouponAdmin',
    serviceName: 'unitadmin',
    query: gql`
      query categoryCouponAdmin(
        $ids: [String]
        $codes: [String]
        $shop_ids: [String]
        $unit_ids: [String]
        $title: String
        $is_active: Int
        $usable: Int
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        categoryCouponAdmin(
          ids: $ids
          codes: $codes
          shop_ids: $shop_ids
          unit_ids: $unit_ids
          title: $title
          is_active: $is_active
          usable: $usable
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          total
          last_page
          data {
            id
            title
            unit {
              title
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'deleteCategoryCoupon',
    serviceName: 'shopadmin',
    query: gql`
      mutation deleteCategoryCoupon($ids: [String]!) {
        deleteCategoryCoupon(ids: $ids) {
          influenced_count
          messages
        }
      }
    `,
  },
  current: {
    name: 'categoryCouponAdmin',
    serviceName: 'unitadmin',
    query: gql`
      query categoryCouponAdmin($ids: [String]) {
        categoryCouponAdmin(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
  assignment: {
    name: 'categoryCouponAdmin',
    serviceName: 'unitadmin',
    query: gql`
      query categoryCouponAdmin($ids: [String]) {
        categoryCouponAdmin(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
